/**
 * File upload panel: shows selected files and allows removing them one by one.
 * Supports adding files in multiple batches (merge on each selection).
 * Works with any element that has [data-rb-file-upload].
 */
(function () {
  function mergeNewFilesIntoInput(container) {
    const fileInput = container?.querySelector("[data-rb-file-input]");
    if (!(fileInput instanceof HTMLInputElement)) return;
    const stored = (container._rbFileList && [...container._rbFileList]) || [];
    const newFiles = Array.from(fileInput.files || []);
    const merged = stored.concat(newFiles);
    container._rbFileList = merged;
    const dt = new DataTransfer();
    merged.forEach((f) => dt.items.add(f));
    fileInput.files = dt.files;
  }

  function syncStoredFileList(container) {
    const fileInput = container?.querySelector("[data-rb-file-input]");
    if (!(fileInput instanceof HTMLInputElement)) return;
    container._rbFileList = Array.from(fileInput.files || []);
  }

  function removeFileAtIndex(fileInput, removeIndex) {
    const files = fileInput.files;
    if (!files || removeIndex < 0 || removeIndex >= files.length) return;
    const dt = new DataTransfer();
    for (let i = 0; i < files.length; i++) {
      if (i !== removeIndex) dt.items.add(files[i]);
    }
    fileInput.files = dt.files;
  }

  function renderFileList(container) {
    const fileInput = container?.querySelector("[data-rb-file-input]");
    const listEl = container?.querySelector("[data-rb-file-list]");
    if (!(fileInput instanceof HTMLInputElement) || !(listEl instanceof HTMLElement)) return;

    const files = fileInput.files;
    const removeLabel = container?.getAttribute("data-rb-remove-label") || "Remove file";

    listEl.innerHTML = "";
    if (!files || files.length === 0) {
      listEl.hidden = true;
      return;
    }
    listEl.hidden = false;
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const li = document.createElement("li");
      li.className = "file-upload-panel__item";
      const nameSpan = document.createElement("span");
      nameSpan.className = "file-upload-panel__name";
      nameSpan.textContent = file.name || "Unnamed file";
      const removeBtn = document.createElement("button");
      removeBtn.type = "button";
      removeBtn.className = "file-upload-panel__remove";
      removeBtn.setAttribute("data-rb-remove-file", String(i));
      removeBtn.setAttribute("aria-label", removeLabel + " " + (file.name || ""));
      removeBtn.textContent = "×";
      li.appendChild(nameSpan);
      li.appendChild(removeBtn);
      listEl.appendChild(li);
    }
  }

  document.addEventListener("click", function (e) {
    const target = e.target;
    if (!(target instanceof Element)) return;

    const trigger = target.closest("[data-rb-trigger-file-upload]");
    if (trigger) {
      e.preventDefault();
      const container = trigger.closest("[data-rb-file-upload]");
      const fileInput = container?.querySelector("[data-rb-file-input]");
      if (fileInput instanceof HTMLInputElement) fileInput.click();
      return;
    }

    const removeBtn = target.closest("[data-rb-remove-file]");
    if (removeBtn) {
      e.preventDefault();
      const idx = parseInt(removeBtn.getAttribute("data-rb-remove-file"), 10);
      if (!Number.isNaN(idx)) {
        const container = removeBtn.closest("[data-rb-file-upload]");
        const fileInput = container?.querySelector("[data-rb-file-input]");
        if (fileInput instanceof HTMLInputElement) {
          removeFileAtIndex(fileInput, idx);
          syncStoredFileList(container);
          renderFileList(container);
        }
      }
      return;
    }
  });

  document.addEventListener("change", function (e) {
    const target = e.target;
    if (!(target instanceof HTMLInputElement) || target.type !== "file") return;
    const container = target.closest("[data-rb-file-upload]");
    if (!container) return;
    mergeNewFilesIntoInput(container);
    renderFileList(container);
  });
})();
